"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListTabs = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var FilterableListTab_1 = require("./FilterableListTab");
var TabsSlider_1 = require("../../../Components/TabsSlider");
var prevSelectedFiltersQuery = null;
var refsCollection = [];
var FilterableListTabs = /** @class */ (function (_super) {
    tslib_1.__extends(FilterableListTabs, _super);
    function FilterableListTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { selectedTabValue: '', selectedTabIndex: 0 };
        _this.onTabSwitch = function (value, tabIndex) {
            var _a;
            (_a = _this.props) === null || _a === void 0 ? void 0 : _a.setIsContentLoading(true);
            _this.setState({
                selectedTabValue: value,
                selectedTabIndex: tabIndex,
            });
            _this.props.onTabSwitch(value);
        };
        return _this;
    }
    FilterableListTabs.prototype.componentDidMount = function () {
        var typeFiltersList = this.props.typeFiltersList;
        var newState = FilterableListTabs.getSelectedFilterData(typeFiltersList);
        this.setState(newState);
    };
    FilterableListTabs.getDerivedStateFromProps = function (props) {
        var typeFiltersList = props.typeFiltersList;
        if (!typeFiltersList)
            return null;
        if (prevSelectedFiltersQuery !== props.selectedFiltersQuery) {
            prevSelectedFiltersQuery = props.selectedFiltersQuery;
            return FilterableListTabs.getSelectedFilterData(typeFiltersList);
        }
        return null;
    };
    FilterableListTabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, typeFiltersList = _a.typeFiltersList, allResultsCount = _a.allResultsCount, allResultsLabel = _a.allResultsLabel;
        var _b = this.state, selectedTabValue = _b.selectedTabValue, selectedTabIndex = _b.selectedTabIndex;
        var allResultsTab = {
            value: '',
            title: allResultsLabel,
            documentsCount: allResultsCount,
        };
        return (React.createElement(TabsSlider_1.TabsSlider, { selectedTabIndex: selectedTabIndex, tabsRefs: refsCollection },
            React.createElement("ul", { className: "filterable-list__tabs-container", role: "tablist" },
                React.createElement(FilterableListTab_1.FilterableListTab, { key: allResultsTab.title, tabDetails: allResultsTab, onTabSwitch: this.onTabSwitch, selected: selectedTabValue === '', tabIndex: 0, ref: function (tab) {
                        refsCollection[0] = tab;
                    } }),
                typeFiltersList.map(function (type, index) { return (React.createElement(FilterableListTab_1.FilterableListTab, { key: type.title, tabDetails: type, onTabSwitch: _this.onTabSwitch, selected: selectedTabValue === type.value, tabIndex: index + 1, ref: function (tab) {
                        refsCollection[index + 1] = tab;
                    } })); }))));
    };
    FilterableListTabs.getSelectedFilterData = function (typeFiltersList) {
        var selectedTabValue = '', selectedTabIndex = 0;
        typeFiltersList.forEach(function (type, index) {
            if (type.selected) {
                selectedTabValue = type.value;
                selectedTabIndex = index + 1;
            }
        });
        return {
            selectedTabValue: selectedTabValue,
            selectedTabIndex: selectedTabIndex,
        };
    };
    return FilterableListTabs;
}(React.Component));
exports.FilterableListTabs = FilterableListTabs;
